/**
 * RA serial number for CPWD-style ordering and "previous RA" chain (same logic Civil / E&M / Horticulture).
 *
 * 1) Use stored ra_no when it is a positive integer.
 * 2) Parse ra_ref / bill number: prefer trailing segment after last hyphen (matches RA-E&M-3, RA-Civil-12,
 *    RA-3, and avoids treating a leading year in "2024/…/RA-E&M-3" as the serial).
 * 3) RA-<digits> only.
 * 4) Legacy: first run of digits in the string.
 */
export function parseRABillSerialNumber(bill) {
  const rawNo = bill?.ra_no ?? bill?.data?.ra_no;
  const direct = Number(rawNo);
  if (Number.isFinite(direct) && direct > 0) return direct;

  const ref = String(
    bill?.ra_ref ?? bill?.billNo ?? bill?.bill_no ?? bill?.data?.ra_ref ?? '',
  ).trim();
  if (!ref) return 0;

  const tail = ref.match(/-(\d+)\s*$/);
  if (tail) {
    const n = Number(tail[1]);
    if (Number.isFinite(n) && n > 0) return n;
  }

  const raPlain = ref.match(/^RA-(\d+)$/i);
  if (raPlain) {
    const n = Number(raPlain[1]);
    if (Number.isFinite(n) && n > 0) return n;
  }

  const any = ref.match(/(\d+)/);
  return any ? Number(any[1]) : 0;
}
